import { smsClient } from '../client';
import type { ReportGroupBy, ReportQuery } from '../types';

export async function fetchReport(query: ReportQuery): Promise<unknown> {
  const { data, error } = await smsClient.GET('/report/', {
    params: { query },
  });
  if (error) throw error;
  return data;
}

export const REPORT_GROUP_BY_OPTIONS: { value: ReportGroupBy; label: string }[] = [
  { value: 'user_id', label: 'Клиент' },
  { value: 'manager_id', label: 'Менеджер' },
  { value: 'partner_id', label: 'Партнер' },
  { value: 'carrier_codes', label: 'Carrier codes' },
  { value: 'mcc', label: 'MCC' },
  { value: 'mnc', label: 'MNC' },
  { value: 'aggregator_id', label: 'Агрегатор' },
  { value: 'direction_id', label: 'Направление' },
  { value: 'country_iso', label: 'Страна' },
  { value: 'message_type', label: 'Тип сообщения' },
  { value: 'created_day', label: 'Created day' },
];
